import React from 'react';
import { utcToDisplayDate } from '../../../common/formatting';

const SelectedProduct = ({ commercialProductId, name, contractPeriod, type, label, image, price = {} }) => commercialProductId? 
    <div className="selected-product-summary clearfix block">
        {image && <img src={image} className="image pull-left"/>}
        <b>Selected product - {type}:</b><br />
        {name} - <b>{price.price}{price.isRecurring? <span>,-/mnd</span>: <span>,-</span>}</b><br />
        {label && <div><i>{label}</i></div>}
        Contract period: {contractPeriod || "1"} <br />
        {price.originalPrice && <div>Original price: {price.originalPrice},-</div>}
        {price.offerName &&  <div>Offer name: {price.offerName}</div>}
        {price.offerStartDate &&  <div>Offer start date: {utcToDisplayDate(price.offerStartDate)}</div>}
        {price.offerEndDate &&  <div>Offer end date: {utcToDisplayDate(price.offerEndDate)}</div>}
    </div>: 
    null;

export default SelectedProduct;